import { render, staticRenderFns } from "./TransactionEntry.vue?vue&type=template&id=38963e9e&scoped=true&"
import script from "./TransactionEntry.vue?vue&type=script&lang=js&"
export * from "./TransactionEntry.vue?vue&type=script&lang=js&"
import style0 from "./TransactionEntry.vue?vue&type=style&index=0&id=38963e9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38963e9e",
  null
  
)

export default component.exports